import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import MediaLayer from "./MediaLayer";


const MediaPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Media" />

        {/* MediaLayer */}
        <MediaLayer />
      </MasterLayout>
    </>
  );
};

export default MediaPage;
